<script setup>
import { ref, computed } from 'vue';
import FileUpload from 'vue-upload-component';
import NextButton from 'dashboard/components-next/button/Button.vue';
import FormFooter from './FormFooter.vue';

const emit = defineEmits(['sendMessage', 'cancel']);

const selectedFile = ref(null);
const previewUrl = ref('');

const onInputFile = newFile => {
  if (!newFile) return;

  selectedFile.value = newFile.file;
  previewUrl.value = URL.createObjectURL(newFile.file);
};

const isValid = computed(() => !!selectedFile.value);

const submit = () => {
  if (!isValid.value) return;

  emit('sendMessage', {
    message: '',
    contentType: 'sticker',
    files: [selectedFile.value],
  });
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <FileUpload
      input-id="evolutionStickerUpload"
      accept="image/*"
      :size="1024 * 1024 * 10"
      @input-file="onInputFile"
    >
      <NextButton
        type="button"
        icon="i-ph-sticker"
        faded
        slate
        :label="
          selectedFile
            ? $t('CONVERSATION.EVOLUTION_INTERACTIVE.STICKER.CHANGE_FILE')
            : $t('CONVERSATION.EVOLUTION_INTERACTIVE.STICKER.UPLOAD_LABEL')
        "
      />
    </FileUpload>
    <img
      v-if="previewUrl"
      :src="previewUrl"
      class="w-24 h-24 object-cover rounded-lg outline outline-1 outline-n-weak"
    />
    <FormFooter
      :disabled="!isValid"
      @cancel="$emit('cancel')"
      @submit="submit"
    />
  </div>
</template>
